'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';

import { IS_POSTHOG_ENABLED } from '@/lib/posthog-enabled';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (IS_POSTHOG_ENABLED) {
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
        api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
        defaults: '2025-05-24',
        autocapture: true,
        // Error tracking: report unhandled errors + promise rejections as
        // `$exception` events. Console errors stay off — too noisy to action.
        capture_exceptions: {
          capture_unhandled_errors: true,
          capture_unhandled_rejections: true,
          capture_console_errors: false
        },
        persistence: 'localStorage+cookie',
        cross_subdomain_cookie: true // Enable cross-subdomain tracking
      });
    }
  }, []);

  if (!IS_POSTHOG_ENABLED) return <>{children}</>;

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
